// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mCZi","importantInfo":"styles_importantInfo__Do_TC"};